import React from 'react';

const HtmlProperties = ({ block, onUpdate }) => {
    return (
        <div className="space-y-4">
            <div>
                <label className="block text-sm font-medium">Code HTML</label>
                <textarea 
                    value={block.content} 
                    onChange={(e) => onUpdate(block.id, { content: e.target.value })} 
                    className="w-full p-2 border rounded font-mono text-sm" 
                    rows="8"
                    placeholder="Collez votre code d'intégration ici (ex: YouTube, Vimeo...)"
                ></textarea>
            </div>
        </div>
    );
};

export default HtmlProperties;